export enum DebtEmployeeType {
    Receiver = 1,
    Delivery = 2
}